import { _Product, _Variant, useGlobalSettings } from "/global-stores";
import { ReactProductState } from "product";
import { FC } from "react";
import { StoreApi, UseBoundStore } from "zustand";

export const ProductLabels: FC<{ useProduct: UseBoundStore<StoreApi<ReactProductState>> }> = ({
  useProduct,
}) => {
  const { product, selectedVariant } = useProduct(({ product, selectedVariant }) => ({
    product,
    selectedVariant,
  }));

  return (
    <div className="flex flex-wrap gap-1">
      <ProductLabelsContent product={product} selectedVariant={selectedVariant} />
    </div>
  );
};

export const ProductLabelsContent: FC<{
  product: _Product;
  selectedVariant: _Variant;
}> = ({ product, selectedVariant }) => {
  const settings = useGlobalSettings();

  const [str_labels_ns, str_labels_key] =
    settings?.product_card__labels_metafield?.split(".") ?? [];
  const [obj_labels_ns, obj_labels_key] =
    settings?.product_card__labels_metaobject?.split(".") ?? [];

  const defaultTextColor = settings.product_card__labels_default_text_color as string;
  const defaultBgColor = settings.product_card__labels_default_bg_color as string;

  const str_labels = product?.metafields?.[str_labels_ns]?.[str_labels_key];
  const obj_labels = product?.metafields?.[obj_labels_ns]?.[obj_labels_key];

  return (
    <>
      {Array.isArray(str_labels)
        ? str_labels?.map((label, index) => {
            return (
              <div
                key={index}
                className="label--md"
                style={{ color: defaultTextColor, backgroundColor: defaultBgColor }}
              >
                {label}
              </div>
            );
          })
        : null}
      {Array.isArray(obj_labels)
        ? obj_labels?.map((label, index) => {
            return (
              <div
                key={index}
                className="label--md"
                style={{ color: label?.color, background: label?.background_color }}
              >
                {label?.label_text}
              </div>
            );
          })
        : null}
      {product?.available && selectedVariant?.price < selectedVariant?.compare_at_price
        ? selectedVariant?.price === 0
          ? <div className="label--md label--primary">FREE</div>
          : <>
              {
                {
                  sale: (
                    <div
                      className="label--md"
                      style={{ color: defaultTextColor, backgroundColor: defaultBgColor }}
                    >
                      On Sale
                    </div>
                  ),
                  percentage: (
                    <div
                      className="label--md"
                      style={{ color: defaultTextColor, backgroundColor: defaultBgColor }}
                    >
                      {Math.round(
                        ((selectedVariant?.compare_at_price - selectedVariant?.price) * 100) /
                          selectedVariant?.compare_at_price
                      )}
                      % Off
                    </div>
                  ),
                  value: (
                    <div
                      className="label--md"
                      style={{ color: defaultTextColor, backgroundColor: defaultBgColor }}
                    >
                      Save{" "}
                      <span
                        dangerouslySetInnerHTML={{
                          __html: window.formatMoney(
                            selectedVariant?.compare_at_price - selectedVariant?.price,
                            window.shop?.money_format?.replace(
                              /\{(\s*)amount(\s*)}/gi,
                              "{$1amount_no_decimals$2}"
                            )
                          ),
                        }}
                      ></span>
                    </div>
                  ),
                }[settings.product_card__labels__discount]
              }
            </>
        : null}
      {!product?.available
        ? <div
            className="label--md"
            style={{ color: defaultTextColor, backgroundColor: defaultBgColor }}
          >
            Sold out
          </div>
        : null}
    </>
  );
};
